<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" canCancel />
    <header class="modal-card-head">
      <p class="modal-card-title is-size-5 has-text-centered">
        {{ cardTitle }}
      </p>
    </header>

    <template>
      <section class="modal-card-body">
        <div class="custom-title">
          <img
            src="@/assets/svg/icon_digital_signature.svg"
            width="60"
            alt=""
          />
          <span class="has-text-color-7 has-text-weight-semibold">
            {{ Home.SELECT_CERTIFICATE_SING_IN }}
          </span>
        </div>
        <div class="wrapper-list-cert">
          <ul>
            <li
              v-for="(cert, index) in getListCerts"
              :key="index"
              class="custom-pointer"
              :class="
                `${
                  selectedCertificate === cert.thumbprint ? 'selected-cert' : ''
                }`
              "
              @click="selectCertificateSign(cert)"
            >
              <div class="block">
                <b-icon type="is-primary" icon="lock" size="is-small" />
                <span>
                  {{ cert.subjectName }} - {{ cert.pkiBrazil.cpf }} ({{
                    cert.issuerName
                  }})
                </span>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="custom-button-docsign">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            :disabled="selectedCertificate === '' || isLoading"
            @click.stop="login"
          >
            <span class="is-size-6">{{ Home.LOG_IN.toUpperCase() }}</span>
          </b-button>
        </div>
      </footer>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { InitLogin, SingIn } from "@/services/lacuna/LacunaSigner";
import { Home, General } from "@/utils/constants";
import ModalWarning from "@/views/App/ModalWarning.vue";

export default {
  name: "ModalDigitalCertificate",

  props: {
    onClose: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      Home,
      General,
      isLoading: false,
      cardTitle: Home.DIGITAL_CERT,
      listCerts: [],
      selectedCertificate: ""
    };
  },

  computed: {
    ...mapGetters({
      userToken: "getUsertokenDigitalCert",
      isContrast: "isContrast"
    }),

    getListCerts() {
      return this.listCerts;
    }
  },

  async beforeMount() {
    this.isLoading = true;
    await InitLogin(this.onWebPkiReady, this.onNotInstalled);
    await this.getTokenDigitalCert();
    this.isLoading = false;
  },

  methods: {
    ...mapMutations({
      setSelectedCertificate: "setSelectedCertificate"
    }),

    ...mapActions({
      getTokenDigitalCert: "getTokenDigitalCert",
      loginDigitalCert: "loginDigitalCert",
      checkCert: "checkValidCertificate"
    }),

    close() {
      this.$parent.close();
      this.onClose();
    },

    onWebPkiReady(certs) {
      this.listCerts = certs;
    },

    onNotInstalled(pki) {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: this.General.MESSAGES.WITHOUT_RESPKI,
          confirm: pki.redirectToInstallPage
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    async selectCertificateSign(cert) {
      this.isLoading = true;
      if (await this.checkCert({ cert, isSignature: false })) {
        this.selectedCertificate = cert.thumbprint;
        this.setSelectedCertificate(cert.thumbprint);
      }
      this.isLoading = false;
    },

    async login() {
      await SingIn(
        {
          token: this.userToken,
          thumbprint: this.selectedCertificate
        },
        async () => {
          this.isLoading = true;
          await this.loginDigitalCert(this.userToken);
          this.isLoading = false;
          this.close();
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  @media screen and (min-width: $tablet) {
    min-width: 800px;
  }
}

.modal-card-body {
  padding: 0 30px;
  background-color: $color-1;
}

.modal-card-foot {
  padding: 15px 30px;
}

.box-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 220px;
  padding: 25px;
  background-color: #84e2d2;
  border-radius: 5px;
}

.cert_img {
  display: flex;
  min-height: 150px;
  align-items: center;
  justify-content: center;
  padding: 5px;
  background-color: $white;
  border-radius: 6px;
  border: 2px solid $primary;
}

footer.modal-card-foot > div.custom-button-docsign {
  width: 100%;
  text-align: right;
  padding: 0 0 15px 0;
}

.wrapper-list-cert {
  border: 2px solid $custom-color-dcdcdc;
  overflow: auto;
  height: 250px;
  border-radius: 5px;
}

.wrapper-list-cert > ul li {
  padding: 6px 10px;
}

.wrapper-list-cert > ul li > div.block {
  display: flex;
  align-content: center;
  align-items: center;
  gap: 10px;
}

.selected-cert,
.wrapper-list-cert > ul li:hover {
  background-color: #cbf6f0;
}

.custom-title {
  display: flex;
  align-content: center;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}
</style>
